import { useRef, useEffect } from 'react';

export function useApiService<T extends { cleanup?: () => void }>(createService: () => T): T {
	const serviceRef = useRef<T | null>(null);

	if (serviceRef.current === null) {
		serviceRef.current = createService();
	}

	useEffect(() => {
		const service = serviceRef.current;

		return () => {
			if (service && typeof service.cleanup === 'function') {
				service.cleanup();
			}
		};
	}, []);

	return serviceRef.current!;
}
